import { PaymentStrategy } from '@ctct/state-server-layer';

import type { Listeners } from '../helpers';
import { controllerHelpers } from '../helpers';
import type { OverdueSummaryManager, PaymentMethodsManager } from '../managers';
import { overdueSummaryEventBus, paymentMethodsEventBus } from '../managers';

export class OverdueSummaryController {
  public listeners: Listeners;

  constructor(private overdueSummary: OverdueSummaryManager, private paymentMethods: PaymentMethodsManager) {
    const eventConnections = [
      paymentMethodsEventBus.bindTo('applePayIFrameLoaded', this.onApplePayIFrameLoaded),
      overdueSummaryEventBus.bindTo('overduePaymentDataUpdated', this.updateApplePayPaymentData),
      paymentMethodsEventBus.bindTo('paymentMethodCanBeUpdated', this.onPaymentMethodCanBeUpdated),
    ];

    this.listeners = controllerHelpers.createListeners(eventConnections);
  }

  private onApplePayIFrameLoaded = async () => {
    const overdueSummaryApi = await this.overdueSummary?.getApiWhenReady();
    const { amount, currency } = overdueSummaryApi.getOverdue();

    const payload = {
      amount,
      currency,
      // we do not show separate tax row for overdue payments
      taxAmount: 0,
    };

    this.updateApplePayPaymentData(payload);
  };

  private updateApplePayPaymentData = async (payload) => {
    const paymentMethodsApi = await this.paymentMethods.getApiWhenReady();

    if (paymentMethodsApi.paymentStrategy !== PaymentStrategy.Paas) {
      return;
    }

    const isApplePayLoaded = paymentMethodsApi.getIsApplePayLoaded();
    const hasNewApplePayToken = paymentMethodsApi.getHasNewApplePayToken();

    if (!isApplePayLoaded && !hasNewApplePayToken) {
      // if apple pay is not loaded (for example not selected as payment method - skip setting the payment data)
      return;
    }

    paymentMethodsApi.setApplePayPaymentData(payload);
  };

  private onPaymentMethodCanBeUpdated = async (canBeUpdated: boolean) => {
    const paymentMethodsApi = await this.paymentMethods.getApiWhenReady();

    if (canBeUpdated) {
      paymentMethodsApi.resetCurrentPaymentMethodWarning();
    } else {
      paymentMethodsApi.setCurrentPaymentMethodWarning();
    }
  };
}
